import { render } from "./ThreeColImageText.vue?vue&type=template&id=38f31864"
import script from "./ThreeColImageText.vue?vue&type=script&lang=js"
export * from "./ThreeColImageText.vue?vue&type=script&lang=js"

import exportComponent from "/home/richard/Code/CHE/project/resources/frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__